import React from 'react'
import Helmet from 'react-helmet'
import GatsbyConfig from '../../../gatsby-config.js'
import SiteFooter from '../partials/site-footer'
import HelmetWrapper from '../partials/helmet-wrapper'
import Image from '../partials/image'
import SiteHeader from '../partials/site-header'
import Timeline from '../partials/timeline'
import { setInLocal } from '../../utils/app-helpers'
import photo from '../../../static/images/troy-and-marisha-mobile.jpg'
import signature from '../../../static/images/signature.png'
import PastPeople from '../partials/past-people'
import PastTrips from '../partials/past-trips'

const { siteMetadata: config } = GatsbyConfig

export default class OurStoryPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props

    setInLocal('lsg.last-viewed-trip', trip)
  }

  render() {
    const { trip } = this.props
    const title = 'Our Story'
    const description =
      'Learn more about how the Love Song Couples Getaway came to be and why ' +
      'we love doing what we do!'

    return (
      <div className={`page-at-root page-our-story trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <SiteHeader trip={trip} />
        <main>
          <div className="wrap">
            <div className="content-split">
              <div>
                <div
                  className="image"
                  style={{
                    backgroundImage: 'url(/images/troy-and-marisha.jpg)',
                  }}
                >
                  <Image src={photo} alt="" />
                </div>
              </div>
              <div className="content">
                <h1 className="lefta">Our Story</h1>
                <p>
                  Travel is our life. Experiencing God’s creation is what gives
                  us joy. For us, travel is an integral part of who we are as a
                  couple. We believe that creating lasting memories together and
                  having experiences that are outside of the realm of typical
                  day-to-day routines is vitally important in any marriage, yet
                  is too often overlooked in this busy world we live in.
                </p>
                <p>
                  The Love Song Couples Getaway came about from our desire to
                  provide couples with a chance to break away from all of the
                  to-do’s and distractions that we all face on a daily basis and
                  present an opportunity to see the world together, fellowship
                  with other believers, and “come apart to a deserted place and
                  rest a while” (Mark 6:31). We are so thrilled that God has
                  given us the opportunity to meet so many incredible couples
                  along the way and that the Love Song Couples Getaway has had
                  such a profound impact on the thousands who have travelled
                  with us. We are living our dream and are thankful for the
                  opportunity to share our love for God & travel with you.
                </p>
                <p>Blessings & Grace,</p>
                <p>
                  <Image className="signature" src={signature} alt="" />
                  <br />Troy &amp; Marisha Tyler
                </p>
              </div>
            </div>
          </div>
          <Timeline />
          <PastPeople />
          <PastTrips />
        </main>
        <SiteFooter trip={trip} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/our-story.js